import { TableColumnMeta } from "ds/components/Table/types";

import { ACTIONS_COLUMN_CONFIG, ActionsColumnId, MAX_CELL_WIDTH } from "./globalTable";

export enum EnvVariablesColumnId {
  NAME = "name",
  DESCRIPTION = "description",
  VALUE = "value",
  SOURCE = "source",
  CREATED_AT = "createdAt",
  ACTIONS = ActionsColumnId.ACTIONS,
}

export const ENV_VARS_COLUMNS_STORAGE_KEY = "environmentVariablesColumnsConfig";

export const ENV_VARS_COLUMNS: Record<EnvVariablesColumnId, TableColumnMeta> = {
  [EnvVariablesColumnId.NAME]: {
    id: EnvVariablesColumnId.NAME,
    title: "Name",
    defaultWidth: 230,
    minWidth: 150,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: false,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [EnvVariablesColumnId.DESCRIPTION]: {
    id: EnvVariablesColumnId.DESCRIPTION,
    title: "Description",
    defaultWidth: 200,
    minWidth: 150,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: false,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [EnvVariablesColumnId.VALUE]: {
    id: EnvVariablesColumnId.VALUE,
    title: "Value",
    defaultWidth: 200,
    minWidth: 120,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: false,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [EnvVariablesColumnId.SOURCE]: {
    id: EnvVariablesColumnId.SOURCE,
    title: "Source",
    defaultWidth: 200,
    minWidth: 150,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: false,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [EnvVariablesColumnId.CREATED_AT]: {
    id: EnvVariablesColumnId.CREATED_AT,
    title: "Created at",
    defaultWidth: 200,
    minWidth: 180,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: false,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [EnvVariablesColumnId.ACTIONS]: ACTIONS_COLUMN_CONFIG,
};
